

import { useEffect } from "react"

const TiledeskWidget = ({ projectId }) => {
  
  useEffect(() => {
    // Check if Tiledesk is already loaded
    if (window.Tiledesk) {
      return
    }

    // Set up Tiledesk settings
    window.tiledeskSettings = {
      projectid: projectId,
    }

    // Create the script loading function
    const loadTiledeskScript = () => {
      const d = document
      const s = "script"
      const id = "tiledesk-jssdk"

      // Check if script already exists
      if (d.getElementById(id)) return

      const js = d.createElement(s)
      const fjs = d.getElementsByTagName(s)[0]

      js.id = id
      js.async = true
      js.src = "https://widget.tiledesk.com/v6/launch.js"

      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs)
      }
    }

    // Initialize Tiledesk function
    const initTiledesk = () => {
      const w = window
      const i = (...args) => {
        i.c(args)
      }
      i.q = []
      i.c = (args) => {
        i.q.push(args)
      }
      w.Tiledesk = i
    }

    // Initialize and load script
    initTiledesk()
    loadTiledeskScript()

    // Cleanup function
    return () => {
      // Optional: Remove script on component unmount
      const script = document.getElementById("tiledesk-jssdk")
      if (script) {
        script.remove()
      }
    }
  }, [projectId])

  return null // This component doesn't render anything visible
}

export default TiledeskWidget